<template>
  <template v-if="Array.isArray(region)">
    <RegionItem
      v-for="subRegion in region"
      :key="subRegion.id"
      :ignoreSelected="ignoreSelected"
      :region="subRegion"
      @select="$emit('select', $event)"
    />
  </template>
  <li
    v-else
    :class="{
      'region-item': true,
      'region-item--empty': (showChildren && !hasChildren),
      'region-item--expanded': region.expanded,
      'region-item--active': region.selected && !ignoreSelected && !checkBox,
      'region-item--error': region.errors,
    }"
  >
    <div
      ref="element"
      class="region-item__header"
    >
      <button
        v-if="showChildren && hasChildren"
        :aria-label="`Expand ${region.name}`"
        class="region-item__arrow"
        type="button"
        @click="region.expanded = !region.expanded"
      >
        <AccordionArrow16Svg class="region-item__arrow-icon" />
      </button>
      <button
        class="region-item__button"
        type="button"
        @click="$emit('select', region)"
      >
        <label class="region-item__title">
          <div
            v-if="checkBox"
            class="checkbox"
          >
            <input
              v-model="region.selected"
              class="checkbox__input"
              type="checkbox"
            >
            <div class="checkbox__label" />
          </div>
          <PolygonSvg
            v-if="!checkBox && region.bounds"
            :bounds="region.bounds"
            :class="`region-item__thumbnail region-item__thumbnail--${region.region_type || 'site'}`"
            :project="project"
            :size="20"
          />
          <span
            class="typo-ignore typo-region-item region-item__title-text"
            :title="region.name"
          >
            {{ itemTitle || $t('regions.untitled_region') }}
          </span>
          <UseSvg
            class="icon icon--small region-item__arrow-right hide-for-medium"
            name="arrow_right_16"
          />
        </label>
      </button>
    </div>

    <ul
      v-if="showChildren && hasChildren"
      class="region-item__sub-regions"
    >
      <RegionItem
        v-for="subRegion in region.children"
        :key="subRegion.id"
        :checkBox="checkBox"
        :ignoreSelected="ignoreSelected"
        :project="project"
        :region="subRegion"
        @select="$emit('select', $event)"
      />
    </ul>
  </li>
</template>

<script>
export default { name: 'RegionItem' };
</script>

<script setup>
import { computed, nextTick, ref, watchEffect } from 'vue';
import I18n from 'i18n-js';

import UseSvg from '@/components/generic/use_svg.vue';
import PolygonSvg from '@/components/generic/polygon_svg.vue';

import AccordionArrow16Svg from '@/images/accordion-arrow-16.svg';

const props = defineProps({
  region: { type: Object, required: true },
  showChildren: { type: Boolean, default: true },
  ignoreSelected: { type: Boolean, default: false },
  checkBox: { type: Boolean, default: false },
  project: { type: Boolean, default: true },
});
defineEmits(['select']);

let element = ref(null);

const hasChildren = computed(() => {
  return props.region.children && props.region.children.length > 0;
});

const itemTitle = computed(() => {
  let translationTypes = I18n.t('shafts.element_types.shaft');

  return translationTypes[props.region.name] || props.region.name;
});

watchEffect(async () => {
  if (props.region.selected && !props.ignoreSelected) {
    await nextTick();
    element.value.scrollIntoView({ behavior: 'smooth', block: 'nearest'});
    let parent = props.region.parent;
    while (parent) {
      parent.expanded = true;
      parent = parent.parent;
    }
  }
});
</script>
